import { createAppAsyncThunk } from "core/src/store/store.types";
import { homePrefix, TokenKeys } from "etl/types";

export type LoginWithPasswordAndEmailRequest = {
	username: string;
	password: string;
};

export type LoginWithPasswordAndEmailResponse = {
	awToken: string;
	awRefreshToken: string;
	user: any;
	username: string;
	password: string;
};

export const loginWithPasswordAndEmail = createAppAsyncThunk<LoginWithPasswordAndEmailResponse, LoginWithPasswordAndEmailRequest>(
	"auth/loginWithPasswordAndEmail",
	async ({ username, password }, { extra }) => {
		const response = await extra.etlClient.loginWithPasswordAndEmail<{ access_token: string, refresh_token: string, profile: any }>(username, password);

		extra.localStorage.setItem(TokenKeys.AW_TOKEN, response.data.access_token);
		extra.localStorage.setItem(TokenKeys.AW_REFRESH_TOKEN, response.data.refresh_token);
		extra.localStorage.setItem("user", JSON.stringify(response.data.profile));
		extra.localStorage.setItem("username", username);
		extra.localStorage.setItem("password", password);

		extra.navigationService.navigate(homePrefix);

		return {
			awToken: response.data.access_token,
			awRefreshToken: response.data.refresh_token,
			user: response.data.profile,
			username,
			password
		};
	}
);
